import React from 'react';
import './App.css';

const ATXTaxis = () => {
    return (
        <div className="atx-taxis">
            <h1 className="atx-taxis-title">ATX Taxis</h1>
            <p className="atx-taxis-description">
                We are Southampton's premier taxi service, offering reliable and efficient transportation in the city and surrounding areas.
            </p>
            <p className="atx-taxis-phone">Call us at: +44 23 8022 2222</p>
            <button className="atx-taxis-button">Book a ride</button>
        </div>
    );
};


export default ATXTaxis;
